import clsx from 'clsx';
import React from 'react';
import styles from './Checkbox.module.scss';

type CheckboxProps = Omit<React.ComponentProps<'input'>, 'type' | 'onChange'> & {
    label?: React.ReactNode;
    helperText?: React.ReactNode;
    onCheckedChange?: (checked: boolean) => void;
};

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, helperText, className, onCheckedChange, disabled, ...inputProps }, ref) => {
        return (
            <label className={clsx(styles.root, { [styles.disabled]: disabled }, className)}>
                <input
                    ref={ref}
                    {...inputProps}
                    disabled={disabled}
                    className={styles.input}
                    onChange={event => onCheckedChange?.(event.target.checked)}
                    type="checkbox"
                />

                {(label || helperText) && (
                    <span className={styles.content}>
                        {label && <span className={styles.label}>{label}</span>}
                        {helperText && <span className={styles.helperText}>{helperText}</span>}
                    </span>
                )}
            </label>
        );
    }
);

Checkbox.displayName = 'Checkbox';
